





import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import { deleteFaxInboxItemRequest, downloadFaxInboxFileRequest, downloadFaxOutboxFileRequest, getCustomerActiveFaxNumbersRequest, getCustomerFaxNumbersRequest, getCustomerHasIvrProductRequest, getFaxInboxRequest, getFaxOutboxRequest, resendFaxRequest, sendFaxRequest } from "../apiRequests/faxRequest";
import { deleteFaxInboxItemErrorAction, deleteFaxInboxItemSuccessAction, downloadFaxInboxFileErrorAction, downloadFaxInboxFileSuccessAction, downloadFaxOutboxErrorAction, downloadFaxOutboxSuccessAction, getCustomerActiveFaxNumberErrorAction, getCustomerActiveFaxNumberSuccessAction, getCustomerFaxNumbersErrorAction, getCustomerFaxNumbersSuccessAction, getFaxInboxErrorAction, getFaxInboxSuccessAction, getFaxOutboxErrorAction, getFaxOutboxSuccessAction, getHasCustomerIvrProductErrorAction, getHasCustomerIvrProductSuccessAction, resendFaxErrorAction, resendFaxSuccessAction, sendFaxErrorAction, sendFaxSuccessAction } from "../../actions/faxActions";
import { FaxInbox, FaxOutbox } from "../../interfaces/fax";








function* getFaxInboxRequestHandler(action: any) {
    try {

        const response: { data: any } = yield call(getFaxInboxRequest, action.payload)
        let inbox = new FaxInbox(response.data);

        // inbox.mapInboxList(response.data.data)
        yield put(
            getFaxInboxSuccessAction(inbox)
        )

    } catch (error: any) {
        yield put(
            getFaxInboxErrorAction({
                error: error.message
            })
        )

    }
}



function* getFaxOutboxRequestHandler(action: any) {
    try {

        const response: { data: number | null } = yield call(getFaxOutboxRequest, action.payload)
        let outbox = new FaxOutbox(response.data)
        yield put(
            getFaxOutboxSuccessAction(outbox)
        )

    } catch (error: any) {
        yield put(
            getFaxOutboxErrorAction({
                error: error.message
            })
        )

    }
}



function* sendFaxRequestHandler(action: any) {
    try {

        const response: { data: number | null } = yield call(sendFaxRequest, action.payload)

        yield put(
            sendFaxSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            sendFaxErrorAction({
                error: error.message
            })
        )

    }
}


function* getCustomerFaxNumbersRequestHandler() {
    try {

        const response: { data: number | null } = yield call(getCustomerFaxNumbersRequest)

        yield put(
            getCustomerFaxNumbersSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getCustomerFaxNumbersErrorAction({
                error: error.message
            })
        )

    }
}


function* getHasCustomerIvrProductRequestHandler() {
    try {

        const response: { data: number | null } = yield call(getCustomerHasIvrProductRequest)

        yield put(
            getHasCustomerIvrProductSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getHasCustomerIvrProductErrorAction({
                error: error.message
            })
        )

    }
}

function* downloadFaxOutboxFileRequestHandler(action: any) {
    try {

        const response: { data: number | null } = yield call(downloadFaxOutboxFileRequest, action.payload)

        yield put(
            downloadFaxOutboxSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            downloadFaxOutboxErrorAction({
                error: error.message
            })
        )

    }
}

function* downloadFaxInboxFileRequestHandler(action: any) {
    try {

        const response: { data: number | null } = yield call(downloadFaxInboxFileRequest, action.payload)

        yield put(
            downloadFaxInboxFileSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            downloadFaxInboxFileErrorAction({
                error: error.message
            })
        )

    }
}

function* deleteFaxInboxItemRequestHandler(action: any) {
    try {

        const response: { data: number | null } = yield call(deleteFaxInboxItemRequest, action.payload)

        yield put(
            deleteFaxInboxItemSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            deleteFaxInboxItemErrorAction({
                error: error.message
            })
        )

    }
}


function* getResendFaxRequestHandler(action: any) {
    try {

        const response: { data: any } = yield call(resendFaxRequest, action.payload)

        yield put(
            resendFaxSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            resendFaxErrorAction({
                error: error.message
            })
        )

    }
}

function* getCustomerActiveFaxNumberRequestHandler() {
    try {

        const response: { data: any } = yield call(getCustomerActiveFaxNumbersRequest)

        yield put(
            getCustomerActiveFaxNumberSuccessAction(response.data)
        )

    } catch (error: any) {
        yield put(
            getCustomerActiveFaxNumberErrorAction({
                error: error.message
            })
        )

    }
}


function* faxSaga() {

    yield all([takeLatest(Types.GET_FAX_INBOX_REQUEST, getFaxInboxRequestHandler)]);
    yield all([takeLatest(Types.GET_FAX_OUTBOX_REQUEST, getFaxOutboxRequestHandler)]);
    yield all([takeLatest(Types.SEND_NEW_FAX_REQUEST, sendFaxRequestHandler)]);
    yield all([takeLatest(Types.GET_CUSTOMER_FAX_NUMBERS_REQUEST, getCustomerFaxNumbersRequestHandler)]);
    yield all([takeLatest(Types.GET_HAS_CUSTOMER_IVR_PRODUCT_REQUEST, getHasCustomerIvrProductRequestHandler)]);
    yield all([takeLatest(Types.GET_DOWNLOAD_OUTBOX_FILE_REQUEST, downloadFaxOutboxFileRequestHandler)]);
    yield all([takeLatest(Types.GET_DOWNLOAD_INBOX_FILE_REQUEST, downloadFaxInboxFileRequestHandler)]);
    yield all([takeLatest(Types.GET_DELETE_INBOX_ITEM_REQUEST, deleteFaxInboxItemRequestHandler)]);
    yield all([takeLatest(Types.GET_RESEND_FAX_REQUEST, getResendFaxRequestHandler)]);
    yield all([takeLatest(Types.GET_CUSTOMER_ACTIVE_FAX_NUMBER_REQUEST, getCustomerActiveFaxNumberRequestHandler)]);





}

export default faxSaga